









































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import {
  IProceed,
  IProceedCreateRequest,
  IProceedListRequest,
  IProceedRequest,
  IProceedUpdateRequest,
} from "@/types/proceed";
import { ProceedRequest } from "@/models/proceed";
import { IEmploymentListRequest } from "@/types/employment";
import { ISelectItem } from "@/types";
import {
  IAlertcondition,
  IAlertconditionCreateRequest,
  IAlertconditionListRequest,
  IAlertconditionRequest,
  IAlertconditionUpdateRequest,
} from "@/types/alertcondition";
import {
  AlertconditionCreateRequest,
  AlertconditionRequest,
  AlertconditionUpdateRequest,
} from "@/models/alertcondition";
import { ITag, ITagListRequest } from "@/types/tag";

@Component({
  components: {},
})
export default class extends Vue {
  @Action("proceed/salesGetList")
  public getProceeds!: (params: IProceedListRequest) => Promise<void>;

  @Action("proceed/salesUpdate")
  public proceedUpdate!: (data: {
    proceed_id: number;
    params: IProceedUpdateRequest;
  }) => Promise<boolean>;

  @Action("proceed/salesCreate")
  public proceedCreate!: (params: IProceedCreateRequest) => Promise<boolean>;

  @Action("proceed/salesDelete")
  public proceedDelete!: (proceed_id: number) => Promise<boolean>;

  @Getter("proceed/partnerProceeds")
  public partnerProceeds!: IProceed[];

  @Getter("proceed/memberProceeds")
  public memberProceeds!: IProceed[];

  @Getter("proceed/offerProceeds")
  public offerProceeds!: IProceed[];

  @Mutation("proceed/clear")
  public clear!: () => void;

  @Action("employment/getList")
  public getEmploymentList!: (params: IEmploymentListRequest) => Promise<void>;

  @Getter("employment/selectItem")
  public employmentList!: ISelectItem[];

  @Action("alertcondition/salesGetList")
  public getAlertconditions!: (
    params: IAlertconditionListRequest
  ) => Promise<void>;

  @Getter("alertcondition/list")
  public alertconditionList!: IAlertcondition[];

  @Action("alertcondition/salesUpdate")
  public alertconditionUpdate!: (data: {
    alertcondition_id: number;
    params: IAlertconditionUpdateRequest;
  }) => Promise<boolean>;

  @Action("alertcondition/salesCreate")
  public alertconditionCreate!: (
    params: IAlertconditionCreateRequest
  ) => Promise<boolean>;

  @Action("alertcondition/salesDelete")
  public alertconditionDelete!: (alertcondition_id: number) => Promise<boolean>;

  @Action("tag/getList")
  public getTags!: (params: ITagListRequest) => Promise<void>;

  @Getter("tag/selectItem")
  public tagList!: ISelectItem[];

  public proceedDialogShown = false;
  public alertconditionDialogShown = false;
  public employmentFilter = false;
  public proceedRequest: IProceedRequest = new ProceedRequest();
  public alertconditionRequest: IAlertconditionRequest =
    new AlertconditionRequest();
  public proceed_id = 0;
  public alertcondition_id = 0;

  private async created() {
    this.clear();

    await Promise.all([
      this.getProceeds({ per_page: 0 }),
      this.getEmploymentList({ per_page: 0 }),
      this.getAlertconditions({ per_page: 0 }),
      this.getTags({ per_page: 0 }),
    ]);
  }

  public proceedDetailClicked(proceed: IProceed): void {
    this.proceedRequest = new ProceedRequest(proceed);
    this.proceed_id = proceed.id;
    this.employmentFilter = !!this.proceedRequest.employment_id;
    this.proceedDialogShown = true;
  }

  public proceedCreateClicked(): void {
    this.proceedRequest = new ProceedRequest();
    this.proceed_id = 0;
    this.employmentFilter = !!this.proceedRequest.employment_id;
    this.proceedDialogShown = true;
  }

  public async proceedEdit(): Promise<void> {
    const result = await this.proceedUpdate({
      proceed_id: this.proceed_id,
      params: this.proceedRequest,
    });

    if (result) {
      this.proceedDialogShown = false;
      await this.getProceeds({ per_page: 0 });
    }
  }

  public async proceedStore(): Promise<void> {
    const result = await this.proceedCreate(this.proceedRequest);
    if (result) {
      this.proceedDialogShown = false;
      await this.getProceeds({ per_page: 0 });
    }
  }

  public async proceedDestroy(): Promise<void> {
    const result = await this.proceedDelete(this.proceed_id);
    if (result) {
      this.proceedDialogShown = false;
      await this.getProceeds({ per_page: 0 });
    }
  }

  public alertDetailClicked(alertcondition: IAlertcondition) {
    this.alertconditionRequest = new AlertconditionUpdateRequest(
      alertcondition
    );
    this.alertcondition_id = alertcondition.id;
    this.alertconditionDialogShown = true;
  }

  public alertconditionCreateClicked() {
    this.alertconditionRequest = new AlertconditionCreateRequest();
    this.alertcondition_id = 0;
    this.alertconditionDialogShown = true;
  }

  public async alertconditionEdit(): Promise<void> {
    const result = await this.alertconditionUpdate({
      alertcondition_id: this.alertcondition_id,
      params: this.alertconditionRequest,
    });
    if (result) {
      this.alertconditionDialogShown = false;
      await this.getAlertconditions({ per_page: 0 });
    }
  }

  public async alertconditionStore(): Promise<void> {
    const result = await this.alertconditionCreate(this.alertconditionRequest);
    if (result) {
      this.alertconditionDialogShown = false;
      await this.getAlertconditions({ per_page: 0 });
    }
  }

  public async alertconditionDestroy(): Promise<void> {
    const result = await this.alertconditionDelete(this.alertcondition_id);
    if (result) {
      this.alertconditionDialogShown = false;
      await this.getAlertconditions({ per_page: 0 });
    }
  }
}
